import { Button, ButtonProps } from "../../ui/button";
import { cn } from "../../../utils/utils";

export default function EndpointActionButton({ className, ...props }: ButtonProps) {
  return (
    <Button
      variant="default"
      size="sm"
      {...props}
      className={cn(
        "endpoint-primary-action flex items-center gap-2 px-5 py-2.5 rounded-xl text-sm font-semibold shadow-md shadow-primary/20 hover:shadow-lg hover:shadow-primary/30 transition-all duration-300",
        className,
      )}
    />
  );
}
